import { S25Util } from "../../../util/s25-util";
import { S25Datefilter } from "../../s25-dateformat/s25.datefilter.service";

export class ImportUtil {
    public static getDateTimeStr(
        startISO8601Str: string,
        endISO8601Str: string,
        timeFormat: string,
        dateTimeFormat: string,
    ): string {
        // if same day date, only show date on end
        let startDt = S25Util.date.parse(startISO8601Str);
        let endDt = S25Util.date.parse(endISO8601Str);
        if (!startDt || !endDt) {
            return "Unknown Date Range";
        }
        if (S25Util.date.equalDate(startDt, endDt)) {
            return (
                S25Datefilter.transform(startDt, dateTimeFormat) + " - " + S25Datefilter.transform(endDt, timeFormat)
            );
        }
        return (
            S25Datefilter.transform(startDt, dateTimeFormat) + " - " + S25Datefilter.transform(endDt, dateTimeFormat)
        );
    }

    public static splitStr(value: string, delim: string) {
        return (
            (value &&
                delim &&
                value
                    .split(delim)
                    .filter((v) => !!v)
                    .filter((v) => !!v.trim())
                    .map((v) => v.trim())) ||
            []
        );
    }

    public static normalize(value: String): String {
        return value
            .toLowerCase()
            .replace(/[^a-z0-9]/g, "") // remove non-alphanumeric characters
            .replace(/s$/, ""); // accept plural or singular
    }
}
